var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-wrapper"},[_c('h1',[_vm._v("Акты "),_c('span',{staticClass:"data-rows-number"},[_vm._v(_vm._s(_vm.total))])]),_vm._v(" "),_c('acts-list')],1)}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0e2f8168","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/views/ProjectActsView.vue
// module id = m14n
// module chunks = 0